const files = require.context('.', false, /\.js$/)
const presets = []

files.keys().forEach(fileName => {
  if (fileName === './index.js') return
  presets.push(files(fileName).default)
})

export default presets
